import React from "react";
import { useLocation } from "react-router-dom";
import EventDetailsContent from "./EventDetailsContent";
import RecentEvent from "./RecentEvent";

const EventDetails = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const eventId = searchParams.get("eid");

  return (
    <>
      <div className="event-details-wrapper">
        <div className="container pt-120 position-relative">
          <div className="row">
            <EventDetailsContent eventId={eventId} />
          </div>
        </div>
      </div>
      <RecentEvent />
    </>
  );
};

export default EventDetails;
